module.exports = __webpack_public_path__ + "img/transfer18.45d6abfb.jpeg";